/* eslint-disable spire/export-styles */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import parse from "html-react-parser";
import * as React from "react";
import { useEffect, useRef } from "react";
import styled from "styled-components";

const enum fields {
    region = "region",
    portalId = "portalId",
    formId = "formId",
    target = "target",
}

interface Props extends WidgetProps {
    fields: {
        [fields.region]: string;
        [fields.portalId]: number;
        [fields.formId]: string;
        [fields.target]: string;
    };
}

const INTHubSpotWidget: React.FunctionComponent<Props> = props => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);
        script.addEventListener("load", () => {
            if ((window as any).hbspt !== undefined) {
                (window as any).hbspt.forms.create({
                    region: props.fields.region,
                    portalId: props.fields.portalId,
                    formId: props.fields.formId,
                    target: "#hubspot",
                });
            }
        });

        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return <div id="hubspot"></div>;
};

const widgetModule: WidgetModule = {
    component: INTHubSpotWidget,
    definition: {
        group: "Basic",
        icon: "Rtf",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.region,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.portalId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.formId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
